import { Modal } from "react-bootstrap";
import { Button } from "../../styles/Button.styled";
import { ErrorModalBody } from "../../styles/Enrollment.styled";

export const ErrorModal = ({
  content,
  handleClose,
}: {
  content: any;
  handleClose: Function;
}) => {
  if (!content) return null;
  return (
    <Modal
      size="lg"
      centered
      animation={false}
      show={true}
      onHide={() => handleClose()}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <ErrorModalBody>
          {content.title && <h2>{content.title}</h2>}
          {content.desc ? <p>{content.desc}</p> : <p></p>}
          {
            <Button onClick={() => handleClose()}>
              {content.buttonTest ? content.buttonTest : "Close"}
            </Button>
          }
        </ErrorModalBody>
      </Modal.Body>
    </Modal>
  );
};
